import { render, staticRenderFns } from "./ListaDePedidos.vue?vue&type=template&id=ebb699f2&scoped=true"
import script from "./ListaDePedidos.vue?vue&type=script&lang=js"
export * from "./ListaDePedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb699f2",
  null
  
)

export default component.exports